import { render } from "./NavigationLinks.vue?vue&type=template&id=6f812c88&scoped=true"
import script from "./NavigationLinks.vue?vue&type=script&lang=js"
export * from "./NavigationLinks.vue?vue&type=script&lang=js"

import "./NavigationLinks.vue?vue&type=style&index=0&id=6f812c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.107.1_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f812c88"]])

export default __exports__